import React from 'react';

/**
 * "• مكتمل" beside a finished lesson — Figma node 16370:189879.
 *
 * background/green-light under green/350, a 6px dot and 12px bold lettering,
 * on a 6px radius. The dot is written after the word so it lands on the word's
 * left in Arabic, where the design has it, and on its right in English.
 */
const StatusTag = ({ children }) => (
    <span
        className={
            'tw-inline-flex tw-items-center tw-gap-[6px] tw-whitespace-nowrap tw-rounded-[6px] ' +
            'tw-bg-v2-student-done-tint tw-px-[10px] tw-py-[4px] tw-text-[12px] tw-font-bold ' +
            'tw-leading-[1.5] tw-text-v2-student-done'
        }
    >
        {children}
        <span aria-hidden className="tw-block tw-size-[6px] tw-shrink-0 tw-rounded-full tw-bg-v2-student-done" />
    </span>
);

export default StatusTag;
